import React from 'react';
import './Referenssit.css';

const Referenssit = () => {
  return (
    <div className="referenssit-container">
      <p>
        <a href="https://www.imdb.com/name/nm4574054/" target="_blank" rel="noopener noreferrer">IMDb</a>
      </p>
    </div>
  );
};

export default Referenssit;